import { useEffect } from "react";

function Preloader() {
  useEffect(() => {
    const el = document.getElementById("preloader");
    if (el) {
      const timer = setTimeout(() => {
        el.style.transition = "opacity 0.5s ease";
        el.style.opacity = "0";
        setTimeout(() => { el.style.display = "none"; }, 500);
      }, 800);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div className="preloader" id="preloader">
      <div className="preloader">
        <div className="waviy position-relative">
          <span className="d-inline-block">N</span>
          <span className="d-inline-block">E</span>
          <span className="d-inline-block">U</span>
          <span className="d-inline-block">R</span>
          <span className="d-inline-block">A</span>
          <span className="d-inline-block">S</span>
          <span className="d-inline-block">P</span>
          <span className="d-inline-block">E</span>
          <span className="d-inline-block">E</span>
          <span className="d-inline-block">C</span>
          <span className="d-inline-block">H</span>
        </div>
      </div>
    </div>
  );
}

export default Preloader;
